<template>
  <div>
    <template-info :bgImg="bgImg" :title="title">
      <div>
        <div class="gtb-detail">
          หากผู้ประกอบการไม่จดทะเบียน VAT จะส่งผลให้
          ผู้ประกอบการไม่สามารถนำภาษีซื้อที่เกิดจากการซื้อสินค้าหรือใช้บริการ
          เพื่อนำมาประกอบกิจการ (จากผู้ขายสินค้าหรือผู้ให้บริการที่จดทะเบียน VAT
          เหมือนกัน) มาขอคืนได้ <br /><br />ทำให้ผู้ประกอบการที่ไม่จด VAT
          ต้องแบกรับภาระ ค่าใช้จ่ายด้านภาษีมากกว่า เพราะ<b
            >ผู้ประกอบการที่จด VAT สามารถนำภาษีซื้อ ที่เกิดจากการการซื้อสินค้า
            หรือใช้บริการ เพื่อนำมาประกอบกิจการมาขอคืนได้</b
          >
          นั่นเอง
        </div>
        <div class="for-mobile">
          <div class="topic-title-special">
            <b>ซื้อสินค้า</b>
          </div>
          <div class="wrap-img-questions">
            <img src="@/assets/icons/Group 3006.svg" />
            <img src="@/assets/icons/Group 3007.svg" />
            <img src="@/assets/icons/Group 3009.svg" />
            <img src="@/assets/icons/Group 2864.svg" />
          </div>
          <div class="box-context">
            <img src="@/assets/icons/Group 2646.svg" />
            <span>
              เราซื้อของมาขายในราคา 100 บาท แต่ไม่เอาใบกำกับภาษี
            </span>
          </div>
          <div class="topic-title-special">
            <b>ขายสินค้า</b>
          </div>
          <div class="wrap-img-questions">
            <img src="@/assets/icons/Group 3010.svg" />
            <img src="@/assets/icons/Group 3012.svg" />
            <img src="@/assets/icons/Group 3013.svg" />
            <img src="@/assets/icons/Group 3014.svg" />
          </div>
          <div class="box-context">
            <img src="@/assets/icons/Group 2646.svg" />
            <span>
              เราขายสินค้าออกไปในราคา 214 บาท แต่เราออกใบกำกับภาษีให้ลูกค้า
            </span>
          </div>
          <div class="topic-title-special">
            <b>เปรียบเทียบการซื้อของแบบมีและไม่มี VAT</b>
          </div>
        </div>
        <div class="special-topic for-desktop">
          <div class="special-title">
            <!-- <img
              class="for-mobile"
              src="@/assets/icons/Group difference.svg"
              alt="group-difference"
            /> -->
            <img
              class=""
              src="@/assets/icons/Group difference desktop.svg"
              alt="group-difference-desktop"
            />
          </div>
        </div>
      </div>
    </template-info>

    <div class="for-mobile">
      <div class="wrap-img-questions">
        <img src="@/assets/icons/Group 3015.svg" />
      </div>
      <div class="remark" style="margin-bottom: 16px;">
        * สามารถนำเอกสารมาเป็นต้นทุนได้ ในงบการเงินจะแสดงกำไร เรา 100 บาท
      </div>
      <div class="remark" style="margin-bottom: 40px;">
        ** ไม่สามารถนำเอกสารมาเป็นต้นทุน ในงบการเงินจะแสดงกำไร เรา 200 บาท
      </div>
    </div>
  </div>
</template>

<script>
import BackgroundImg from "@/assets/images/infos/goods_tax.png";

export default {
  name: "GoodsTax",
  components: {},
  data() {
    const bgImg = BackgroundImg;
    return {
      bgImg: bgImg,
      title: "ความแตกต่างของการซื้อของ\nแบบมี VAT และไม่มี VAT",
    };
  },
};
</script>

<style scoped>
.gtb-detail {
  width: 100%;
  color: #393d43;
  margin-bottom: 20px;
  text-align: left;
}

.special-topic .topic-wrapper {
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;
  padding: unset;
}
.remark {
  font-size: 14px;
  padding: 0 33px;
}
.topic-title-special {
  width: 100%;
  display: flex;
  border-bottom: 1px solid #eff1f5;
  margin-bottom: 16px;
}
.wrap-img-questions {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.wrap-img-questions img {
  width: 100%;
  max-width: 414px;
  margin-bottom: 24px;
}
.box-context {
  border: 1px solid #99d6f1;
  padding: 9px 33px;
  padding-right: 9px;
  display: flex;
  border-radius: 5px;
  color: #99d6f1;
  align-items: center;
  margin-bottom: 50px;
}
.box-context img {
  margin-right: 20px;
}
.special-title {
  display: flex;
  width: 100%;
  justify-content: center;
  margin-bottom: 50px;
}

.special-title > img {
  width: 100%;
}

.for-mobile {
  display: block;
}
.for-desktop {
  display: none;
}

/*size  >768px */
@media only screen and (min-width: 769px) {
  .for-mobile {
    display: none;
  }
  .for-desktop {
    display: block;
  }
}
</style>
